<template>
	<v-snackbar v-model="show" class="snackbar" v-bind="$attrs">
		<slot />

		<!-- NOTE: This needs to be replaced with `<template #action>` when vuetify is updated -->
		<slot name="close">
			<v-btn
				dark
				text
				:color="textColor"
				@click="show = false"
				v-text="closeText"
			/>
		</slot>
	</v-snackbar>
</template>

<style lang="scss" scoped>
.snackbar.v-snack--top {
	// 56px app bar + 8px margin
	top: 64px;

	@media #{map-get($display-breakpoints, 'md-and-up')} {
		// 64px app bar + 8px margin
		top: 72px;
	}
}
</style>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			required: true,
		},

		closeText: {
			type: String,
			default: "OK",
		},

		textColor: {
			type: String,
			default: "ocean lighten-1",
		},
	},

	computed: {
		show: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
};
</script>
